import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-epoq-blue text-epoq-white pt-24 pb-12 px-6 lg:px-12 border-t border-epoq-blue/10">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 border-b border-epoq-white/20 pb-16">
        <div className="lg:col-span-2">
          <Logo dark className="w-40 mb-8" />
          <p className="text-xl font-serif font-light opacity-80 max-w-sm leading-relaxed">
            Practical learning for responsible business transformation.
          </p>
        </div>
        
        <div>
          <h4 className="text-xs uppercase tracking-widest font-semibold mb-6 text-epoq-lime">Navigation</h4>
          <ul className="space-y-4 text-sm opacity-80">
            <li><Link to="/programmes" className="hover:text-epoq-lime transition-colors">Programmes</Link></li>
            <li><Link to="/for-organisations" className="hover:text-epoq-lime transition-colors">For Organisations</Link></li>
            <li><Link to="/about" className="hover:text-epoq-lime transition-colors">About</Link></li>
            <li><Link to="/contact" className="hover:text-epoq-lime transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-xs uppercase tracking-widest font-semibold mb-6 text-epoq-lime">Legal</h4>
          <ul className="space-y-4 text-sm opacity-80">
            <li><Link to="#" className="hover:text-epoq-lime transition-colors">Privacy</Link></li>
            <li><Link to="#" className="hover:text-epoq-lime transition-colors">Cookie policy</Link></li>
          </ul>
        </div>
      </div>
      
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center pt-8 text-xs opacity-50">
        <p>&copy; {new Date().getFullYear()} EPOQ Learn. All rights reserved.</p>
        <p className="mt-4 md:mt-0">Part of EPOQ Assets</p>
      </div>
    </footer>
  );
};

export default Footer;